import BaseApi from './BaseApi'

class InvestorDescriptionsApi extends BaseApi {
  get investorDescriptionsUrl () {
    return 'investorDescriptions'
  }

  fetchingInvestorDescriptions (investorDescriptions) {
    return this.getJson(this.investorDescriptionsUrl, investorDescriptions)
  }
}
export default InvestorDescriptionsApi

